import { FiFilePlus, FiFolder, FiUser } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import './homepage-shortcuts.css';
export default function HomepageShortcuts() {
  const navigate = useNavigate();

  const items = [
    {
      icon: FiFilePlus,
      label: "Nouvelle demande",
      to: "/formalities/templates",
    },
    {
      icon: FiFolder,
      label: "Mes demandes",
      to: "/customer/account/formalities",
    },
    {
      icon: FiUser,
      label: "Mon compte",
      to: "/customer/account/profile",
    },
  ];

  return (
    <div className="container">
      <div className="row g-4 justify-content-center">
        {items.map((item, idx) => {
          const Icon = item.icon;

          return (
            <div key={idx} className="col-12 col-md-3">
              <div
                className="homepage-shortcut"
                onClick={() => navigate(item.to)}
              >
                <div className="shortcut-icon">
                  <Icon size={48} />
                </div>

                <div className="shortcut-label">
                  {item.label}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
